class VueTooltip {
  constructor() {
    this.availableTriggers = ['click', 'hover', 'focus', 'manual'];
  }

  create(el, binding, { props }) {
    const $el = $(el);
    const trigger = this.getTrigger(binding);
    const html = binding.modifiers.html ?? false;
    const title = binding.value ?? props.title ?? '';
    const placement = binding.arg || 'top';

    $el.tooltip({
      title,
      placement,
      boundary: 'window',
      trigger,
      html,
    });

    trigger.indexOf('click') === -1 && $el.on('click', () => $el.tooltip('hide'));
  }

  getTrigger(binding) {
    return this.hasTriggerModifiers(binding) ? this.buildTrigger(binding) : 'hover focus';
  }

  hasTriggerModifiers(binding) {
    for (const trigger of this.availableTriggers) {
      if (binding.modifiers[trigger]) {
        return true;
      }
    }

    return false;
  }

  buildTrigger(binding) {
    const t = [];

    for (const trigger of this.availableTriggers) {
      if (binding.modifiers[trigger]) {
        t.push(trigger);
      }
    }

    return t.join(' ');
  }

  static destroy(el) {
    $(el).tooltip('dispose');
  }
}

const tooltip = new VueTooltip();

export const create = (el, binding, vNode) => {
  if (!Object.prototype.hasOwnProperty.call(binding, 'value') || !binding.value) {
    return;
  }

  tooltip.create(el, binding, { props: vNode.props ?? {} });
};

export const update = (el, binding, vNode) => {
  if (!Object.prototype.hasOwnProperty.call(binding, 'value') || !binding.value) {
    $(el).tooltip('dispose');
    return;
  }

  if (!$(el).data('bs.tooltip')) {
    tooltip.create(el, binding, vNode);
    return;
  }

  $(el).attr('data-original-title', binding.value);
};

export const beforeUnmount = () => VueTooltip.destroy();
